import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { inputClass } from '../components/ui/inputClass';
import { resetPassword } from '../api/auth';
import { ApiError } from '../lib/api';

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';
  const token = params.get('token') ?? '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const nav = useNavigate();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault(); setErr(null);
    if (pw !== pw2) { setErr('Passwords do not match.'); return; }
    if (!email || !token) { setErr('Invalid reset link.'); return; }
    setBusy(true);
    try {
      await resetPassword(email, token, pw);
      setDone(true);
      setTimeout(() => nav('/login', { replace: true }), 1500);
    } catch (e) {
      const body = (e instanceof ApiError ? e.body : null) as { errors?: string[] } | null;
      setErr(body?.errors?.[0] ?? 'Reset failed. The link may have expired.');
    }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-50">Set a new password</h1>
        </div>
        {done ? (
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 shadow-sm text-sm text-slate-600 dark:text-slate-300">
            Password reset. Redirecting to sign in…
          </div>
        ) : (
          <form onSubmit={onSubmit} className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 space-y-4 shadow-sm">
            <div>
              <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300">New password</label>
              <input className={inputClass} type="password" required minLength={6} value={pw} onChange={e => setPw(e.target.value)} />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300">Confirm password</label>
              <input className={inputClass} type="password" required minLength={6} value={pw2} onChange={e => setPw2(e.target.value)} />
            </div>
            {err && <p className="text-sm text-red-500">{err}</p>}
            <button
              className="w-full rounded-lg bg-teal-600 dark:bg-teal-500 py-2.5 text-sm font-semibold text-white hover:bg-teal-700 dark:hover:bg-teal-600 disabled:opacity-50 transition-colors cursor-pointer"
              disabled={busy}
            >
              {busy ? 'Saving…' : 'Reset password'}
            </button>
            <p className="text-center text-sm text-slate-500 dark:text-slate-400">
              <Link className="font-medium text-teal-600 dark:text-teal-400 hover:underline" to="/login">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
